import { defineMessages } from 'react-intl-next';

export default defineMessages({
	changeboardingTitle: {
		id: 'jira.filter.refinement.filter-popup.changeboarding.title',
		defaultMessage: 'Introducing a new home for filters',
		description: 'Title for the first step of the filter refinement changeboarding',
	},
	changeboardingPageTwoTitle: {
		id: 'jira.filter.refinement.filter-popup.changeboarding.page2.title',
		defaultMessage: "We've updated epic to parent",
		description: 'Title for the second step of the filter refinement changeboarding',
	},
	changeboardingNextButton: {
		id: 'jira.filter.refinement.filter-popup.changeboarding.next',
		defaultMessage: 'Next',
		description: 'Label for next button to open the next spotlight',
	},
	changeboardingDismissButton: {
		id: 'jira.filter.refinement.filter-popup.changeboarding.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Label for dismiss button to close the spotlight',
	},
	changeboardingOkButton: {
		id: 'jira.filter.refinement.filter-popup.changeboarding.ok',
		defaultMessage: 'OK',
		description: 'Label for OK button to close the spotlight',
	},
	changeboardingDescriptionFilterByStatusAndPriority: {
		id: 'jira.filter.refinement.filter-popup.changeboarding.description.filter',
		defaultMessage:
			'You can now filter work items by status and priority, making it easier to find work.',
		description:
			'Description shown in the spotlight card, informing users they can filter by status and priority now',
	},
	changeboardingDescriptionMoreImprovements: {
		id: 'jira.filter.refinement.filter-popup.changeboarding.description.improvements',
		defaultMessage: 'More improvements to come.',
		description:
			'Description shown in the spotlight card, informing users that there are upcoming improvements',
	},
	changeboardingDescriptionParentHasReplacedEpic: {
		id: 'jira.filter.refinement.filter-popup.changeboarding.description.parent',
		defaultMessage:
			'Use the parent filter to search for epics, as well as any other work items with child work items.',
		description: 'Description of the Parent field replacing Epic',
	},
});
